export const setTitle = (route) => {
  if (route.path === window.location.pathname) {
    document.title = route.name;
  }
};
